import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as GroupIconSvg } from '../../assets/group-icon.svg';

export const GroupIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={GroupIconSvg} {...props} />;
};
